export const Types = {
  GET_LIST_CAMPANHAS: "campanhas/GET_LIST_CAMPANHAS",
  GET_LIST_CAMPANHAS_SUCCESS: "campanhas/GET_LIST_CAMPANHAS_SUCCESS",
  GET_CAMPANHAS: "campanhas/GET_CAMPANHAS",
  GET_CAMPANHAS_SUCCESS: "campanhas/GET_CAMPANHAS_SUCCESS",
  EDIT_CAMPANHAS: "campanhas/EDIT_CAMPANHAS",
  ADD_CAMPANHAS: "campanhas/ADD_CAMPANHAS",
  DELETE_CAMPANHAS: "campanhas/DELETE_CAMPANHAS",
  SEARCH_CAMPANHAS: "campanhas/SEARCH_CAMPANHAS",
  CHANGE_PAGE_CAMPANHAS: "campanhas/CHANGE_PAGE_CAMPANHAS",
  CHANGE_ROWS_PER_PAGE_CAMPANHAS: "campanhas/CHANGE_ROWS_PER_PAGE_CAMPANHAS",
  DELETE_ALL_CAMPANHAS: "statusAtendimento/DELETE_ALL_CAMPANHAS"
};

const INITIAL_STATE = {
  data: [],
  item: {},
  filter: {},
  page: 0,
  rowsPerPage: localStorage.getItem("@ecorban-app:rows")
    ? parseInt(localStorage.getItem("@ecorban-app:rows"), 10)
    : 10,
  total: 0
};

export default function campanhas(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_LIST_CAMPANHAS:
      return { ...state };
    case Types.GET_LIST_CAMPANHAS_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        total: action.payload.total
      };
    case Types.GET_CAMPANHAS_SUCCESS:
      return {
        ...state,
        item: action.payload.data
      };
    case Types.ADD_CAMPANHAS:
      return { ...state };
    case Types.DELETE_CAMPANHAS:
      return { ...state };
    case Types.CHANGE_PAGE_CAMPANHAS:
      return { ...state, page: action.payload.page };
    case Types.SEARCH_CAMPANHAS:
      return { ...state, filter: action.payload.filter };
    case Types.CHANGE_ROWS_PER_PAGE_CAMPANHAS:
      return { ...state, rowsPerPage: action.payload.total };
    case Types.DELETE_ALL_CAMPANHAS:
      return { ...state };
    default:
      return state;
  }
}

export const Creators = {
  getListCampanhas: () => ({
    type: Types.GET_LIST_CAMPANHAS
  }),
  getListCampanhasSuccess: (data, total) => ({
    type: Types.GET_LIST_CAMPANHAS_SUCCESS,
    payload: { data, total }
  }),
  getCampanhas: id => ({
    type: Types.GET_CAMPANHAS,
    payload: { id }
  }),
  getCampanhasSuccess: data => ({
    type: Types.GET_CAMPANHAS_SUCCESS,
    payload: { data }
  }),
  editCampanhas: data => ({
    type: Types.EDIT_CAMPANHAS,
    payload: data
  }),
  addCampanhas: data => ({
    type: Types.ADD_CAMPANHAS,
    payload: data
  }),
  deleteCampanhas: () => ({
    type: Types.DELETE_CAMPANHAS
  }),
  searchCampanhas: filter => ({
    type: Types.SEARCH_CAMPANHAS,
    payload: { filter }
  }),
  changeCampanhasPage: page => ({
    type: Types.CHANGE_PAGE_CAMPANHAS,
    payload: { page }
  }),
  changeCampanhasRowsPerPage: total => ({
    type: Types.CHANGE_ROWS_PER_PAGE_CAMPANHAS,
    payload: { total }
  }),
  deleteAllCampanhas: selected => ({
    type: Types.DELETE_ALL_CAMPANHAS,
    payload: { selected }
  })
};



// WEBPACK FOOTER //
// ./src/store/ducks/campanhas.js